// Legacy constants - kept for backwards compatibility
export const CODA_EXTRABOLD_DISPLAY_SIZE = '1.8rem';
export const CODA_EXTRABOLD_MOBILE_SIZE = '1.4rem';

// Font size constants — clean, modern typographic scale

// Large title - for hero sections only
export const FONT_LARGE_TITLE = '1.8rem';
export const FONT_LARGE_TITLE_MOBILE = '1.4rem';

// Title - for main page headings
export const FONT_TITLE = '1.4rem';
export const FONT_TITLE_MOBILE = '1.1rem';

// Title 2 - for second level headings
export const FONT_TITLE2 = '1.15rem';
export const FONT_TITLE2_MOBILE = '1.05rem';

// Title 3 - for third level headings
export const FONT_TITLE3 = '1.05rem';
export const FONT_TITLE3_MOBILE = '0.95rem';

// Headline - for emphasized text
export const FONT_HEADLINE = '0.92rem';
export const FONT_HEADLINE_MOBILE = '0.88rem';

// Subheadline - for secondary emphasized text
export const FONT_SUBHEADLINE = '0.88rem';

// Body - for standard text
export const FONT_BODY = '0.85rem';

// Callout - for slightly emphasized body text
export const FONT_CALLOUT = '0.83rem';

// Footnote - for supporting text
export const FONT_FOOTNOTE = '0.78rem';

// Caption - for small text
export const FONT_CAPTION = '0.72rem';

// Caption 2 - for the smallest text
export const FONT_CAPTION2 = '0.68rem';
